// extracted by mini-css-extract-plugin
export default {"banner1":"index_banner1_zW5bj","bref":"index_bref_jG2fs","banner2":"index_banner2_rRLL4"};